export default __webpack_public_path__ + "static/media/supertaco.65056400.jpeg";